import React, { useEffect, useMemo, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import "flatpickr/dist/themes/material_blue.css";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { format } from "date-fns";
import InputMask from "react-input-mask";
import {
  Col,
  Row,
  Card,
  CardBody,
  CardTitle,
  Nav,
  NavItem,
  NavLink,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  FormGroup,
  Label,
  Input,
} from "reactstrap";
import Select from "react-select";
import Spinners from "components/Common/Spinner";
import { ToastContainer } from "react-toastify";
import { useParams } from "react-router-dom";
import IdentificationCard from "components/Common/IdentificationCard";
import SouscriptionsCard from "components/Common/SouscriptionsCard";
import TableComponent from "components/Common/TableComponent";
import { use } from "i18next";
//import { C } from "@fullcalendar/core/internal-common";
import Config from "config";
import useDebounce from "./useDebounce";
function EditCgp() {
  const backUrl = Config.backOffice.url;
  const api = Config.backOffice.apiName;
  let { id } = useParams();
  const navigate = useNavigate();
  const tableaustyles = {
    background: "#555B21",
    color: "white",
    paddingTop: "5px",
    paddingBottom: "5px",
  };
  const colStyle = {
    width: "20em", // Largeur fixe pour la première colonne
    whiteSpace: "wrap", // Empêche le texte de revenir à la ligne
    display: "inline-block", // Permet de conserver le texte sur une seule ligne
    color: "#7f7f7f",
    verticalAlign: "middle", // Alignement vertical au centre pour le texte
    display: "flex", // Utilisation de flexbox pour aligner les éléments horizontalement
    alignItems: "center", // Centrage vertical du texte et de l'input
  };
  const layout = localStorage.getItem("layoutMode");

  const styles = (hasError) => ({
    container: (provided) => ({
      ...provided,
      overflow: "visible",
      fontSize: "0.7109375rem",
    }),
    menu: (provided) => ({
      ...provided,
      textAlign: "left",
      overflow: "visible",
      backgroundColor: layout === "dark" ? "#2A3042" : "#fff", // Couleur de fond selon le mode
      color: layout === "dark" ? "#fff" : "#000", // Couleur du texte selon le mode
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isSelected
        ? "#555B21"
        : layout === "dark"
        ? "#444"
        : "transparent", // Ajustement du background selon le mode
      color: state.isSelected ? "white" : layout === "dark" ? "#fff" : "black", // Ajustement de la couleur selon le mode
      textAlign: "left",
      fontWeight: "normal",
      paddingLeft: 40,
      paddingTop: 10,
    }),
    groupHeading: (provided) => ({
      ...provided,
      fontWeight: "bold",
      fontSize: "15px",
      color: layout === "dark" ? "white" : "black", // Couleur selon le mode
      textAlign: "left",
    }),

    control: (provided, state) => ({
      ...provided,
      //height: "1.69125rem",
      minHeight: "1.69125rem",
      border: state.isFocused
        ? hasError
          ? "1px solid red"
          : layout === "dark"
          ? "1px solid #555"
          : "1px solid #ccc"
        : hasError
        ? "1px solid red"
        : layout === "dark"
        ? "1px solid #555"
        : "1px solid #ccc", // Ajustement de la bordure selon le mode
      backgroundColor: layout === "dark" ? "#2A3042" : "#fff", // Background du contrôle selon le mode
      boxShadow: "none",
      "&:hover": {
        border: hasError
          ? "1px solid red"
          : layout === "dark"
          ? "1px solid #555"
          : "1px solid #ccc", // Ajustement de la bordure au survol selon le mode
      },
    }),
    dropdownIndicator: (base) => ({
      ...base,
      padding: "2px",
    }),
    clearIndicator: (base) => ({
      ...base,
      padding: "2px",
    }),
  });
  const [loading, setLoading] = useState(true);
  const [value, setValue] = useState("");
  const [value1, setValue1] = useState("");
  const handleValueChange = (value) => {
    setValue(value);
  };
  const handleValue1Change = (value) => {
    setValue1(value);
  };
  const token = localStorage.getItem("auth_token_" + api);
  const [cgpData, setCgpData] = useState([]);
  //meta title

  const [activeTab, setActiveTab] = useState("details"); // État pour contrôler l'affichage
  // QUICK ADD PM
  /*************************   Pays  *******************************/
  const [payData, setPayData] = useState({ data: [] });
  const renderPaysOptions = () => {
    return [
      {
        options: payData.data.map((dataItem) => ({
          label: dataItem.label,
          value: dataItem.id,
        })),
      },
    ];
  };

  const getPay = async () => {
    try {
      fetch(`https://www.fluxod.com/${api}/investisseurs/pays`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
        .then((response) => response.json())
        .then((pay) => {
          setPayData(pay);
        });
    } catch (error) {
      console.log(error);
    }
  };
  /*************************   END Pays *******************************/
  const [modalOpen, setModalOpen] = useState(false);
  const toggleModal = () => {
    setModalOpen(!modalOpen);
  };
  const [raisonSociale, setRaisonSociale] = useState("");
  const [email, setEmail] = useState("");
  const [telephone, setTelephone] = useState("");
  const [fax, setFax] = useState("");
  const [adresse, setAdresse] = useState("");
  const [codePostal, setCodePostal] = useState("");
  const [ville, setVille] = useState("");
  const [payId, setPayId] = useState(null);
  const [forceRender, setForceRender] = useState(false);
  const [forceRender2, setForceRender2] = useState(false);
  const [forceRender3, setForceRender3] = useState(false);
  const handleSave = () => {
    // Création de l'objet de données à envoyer
    const newData = {
      raison_sociale: raisonSociale,
      email: email,
      telephone: telephone,
      fax: fax,
      adresse: adresse,
      code_postal: codePostal,
      ville: ville,
      pay_id: payId?.value,
    };

    // Configuration de la requête
    const requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(newData),
    };

    // Envoi de la requête
    fetch(
      `https://www.fluxod.com/${api}/partenaires_exploitants/create_societe`,
      requestOptions
    )
      .then((response) => {
        if (!response.ok) {
          return response.text().then((errorText) => {
            // Convertir le texte de l'erreur en JSON
            const errorMessage = JSON.parse(errorText);
            // Vérifier si "error" est un tableau et afficher tous les messages d'erreur
            if (Array.isArray(errorMessage["error"])) {
              errorMessage["error"].forEach((message) => {
                toast.error(message);
              });
            } else {
              toast.error("Erreur réseau");
            }
            throw new Error(
              errorMessage["error"].join(", ") || "Erreur réseau"
            );
          });
        }
        return response.json();
      })
      .then((data) => {
        console.log("Données sauvegardées avec succès:", data);
        setSelectedPm(data);
        setForceRender(!forceRender); // Forcer le re-render du composant

        toast.success("La personne morale a été créée avec succès.");
        setModalOpen(false); // Fermer le modal après avoir sauvegardé
      })
      .catch((error) => {
        console.error("Erreur lors de la sauvegarde des données:", error);
        // Gérer les erreurs, par exemple afficher un message d'erreur à l'utilisateur
      });
  };
  // Quick add PP
  /*************************   Titre  *******************************/
  const [titreData, setTitreData] = useState({ data: [] });
  const [selectedTitre, setSelectedTitre] = useState("");
  const renderTitreOptions = () => {
    return [
      {
        options: titreData.data.map((dataItem) => ({
          label: dataItem.label,
          value: dataItem.id,
        })),
      },
    ];
  };

  const handleTitreChange = (e) => {
    setSelectedTitre(e);
  };
  const getTitre = async () => {
    try {
      fetch(`https://www.fluxod.com/${api}/investisseurs/titres`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
        .then((response) => response.json())
        .then((titre) => {
          setTitreData(titre);
        });
    } catch (error) {
      console.log(error);
    }
  };
  /*************************   END Titre *******************************/
  const [modalOpen1, setModalOpen1] = useState(false);
  const [titreId, setTitreId] = useState(null);
  const [nom, setNom] = useState("");
  const [prenom, setPrenom] = useState("");
  const [dateDeNaissance, setDateDeNaissance] = useState("");
  const [villeDeNaissance, setVilleDeNaissance] = useState("");
  const [departementOuPays, setDepartementOuPays] = useState("");
  const [profession, setProfession] = useState("");
  const [adresse1, setAdresse1] = useState("");
  const [complement, setComplement] = useState("");
  const [codePostal1, setCodePostal1] = useState("");
  const [ville1, setVille1] = useState("");
  const [payId1, setPayId1] = useState(null);
  const [telFix, setTelFix] = useState("");
  const [telMobil, setTelMobil] = useState("");
  const [emailPro, setEmailPro] = useState("");
  const [emailPerso, setEmailPerso] = useState("");

  const [forceRender1, setForceRender1] = useState(false); // Nouvel état pour forcer le re-render
  const [societeId, setSocieteId] = useState(null);
  const [situationMatrimonial, setSituationMatrimonial] = useState(null);
  const handleSocieteChange = (selectedOption) => {
    setSocieteId(selectedOption);
  };
  const handleSituationMatrimonialChange = (selectedOption) => {
    setSituationMatrimonial(selectedOption);
  };
  const toggleModal1 = () => {
    setModalOpen1(!modalOpen1);
  };

  const handleTitreIdChange = (selectedOption) => {
    setTitreId(selectedOption);
  };

  const handlePayIdChange = (selectedOption) => {
    setPayId1(selectedOption);
  };
  const handleSave1 = () => {
    // Création de l'objet de données à envoyer
    const newData = {
      titre_id: titreId,
      nom: nom,
      prenom: prenom,
      date_de_naissance: dateDeNaissance,
      ville_de_naissance: villeDeNaissance,
      departement_ou_pays: departementOuPays,
      profession: profession,
      adresse: adresse1,
      complement: complement,
      code_postal: codePostal1,
      ville: ville1,
      pay_id: payId1,
      tel_fix: telFix,
      tel_mobil: telMobil,
      email_pro: emailPro,
      societe_id: societeId,

      situation_matrimoniale_id: situationMatrimonial,
      email_perso: emailPerso,
    };

    // Configuration de la requête
    const requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(newData),
    };

    // Envoi de la requête
    fetch(
      `https://www.fluxod.com/${api}/partenaires_exploitants/create_contact`,
      requestOptions
    )
      .then((response) => {
        if (!response.ok) {
          return response.text().then((errorText) => {
            // Convertir le texte de l'erreur en JSON
            const errorMessage = JSON.parse(errorText);
            // Vérifier si "error" est un tableau et afficher tous les messages d'erreur
            if (Array.isArray(errorMessage["error"])) {
              errorMessage["error"].forEach((message) => {
                toast.error(message);
              });
            } else {
              toast.error("Erreur réseau");
            }
            throw new Error(
              errorMessage["error"].join(", ") || "Erreur réseau"
            );
          });
        }
        return response.json();
      })
      .then((data) => {
        console.log("Données sauvegardées avec succès:", data);
        setSelectedPp(data);
        setForceRender1(!forceRender1); // Forcer le re-render du composant

        toast.success("La personne physique a été créée avec succès.");
        toggleModal1(); // Fermer le modal après avoir sauvegardé
      })
      .catch((error) => {
        console.error("Erreur lors de la sauvegarde des données:", error);
        // Gérer les erreurs, par exemple afficher un message d'erreur à l'utilisateur
      });
  };
  /*************************   Type Partenaire *******************************/
  const [typePartenaireData, setTypePartenaireData] = useState({ data: [] });
  const [selectedType, setSelectedType] = useState("");
  const handleTypeChange = (e) => {
    setSelectedType(e);
  };
  const getType = async () => {
    try {
      fetch(
        `https://www.fluxod.com/${api}/partenaires_exploitants/types_partenaires`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
        .then((response) => response.json())
        .then((type) => {
          setTypePartenaireData(type);
        });
    } catch (error) {
      console.log(error);
    }
  };
  const renderTypeOptions = () => {
    return [
      {
        options: typePartenaireData.data.map((dataItem) => ({
          label: dataItem.label,
          value: dataItem.id,
        })),
      },
    ];
  };
  /*************************   SituationMatrimoniale  *******************************/
  const [situationMatrimonialeData, setSituationMatrimonialeData] = useState({
    data: [],
  });

  const [selectedSituationMatrimoniale, setSelectedSituationMatrimoniale] =
    useState("");

  const renderSituationMatrimonialOptions = () => {
    return [
      {
        options: situationMatrimonialeData.data.map((dataItem) => ({
          label: dataItem.label,
          value: dataItem.id,
        })),
      },
    ];
  };
  const handleSituationMatrimonialeChange = (e) => {
    setSelectedSituationMatrimoniale(e);
  };
  const getSituationMatrimoniale = async () => {
    try {
      fetch(
        `https://www.fluxod.com/${api}/investisseurs/situation_matrimoniales`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
        .then((response) => response.json())
        .then((situationMatrimoniale) => {
          setSituationMatrimonialeData(situationMatrimoniale);
        });
    } catch (error) {
      console.log(error);
    }
  };
  /*************************   Societe  *******************************/
  const [societeData, setSocieteData] = useState({ data: [] });
  const renderSocieteOptions = () => {
    return [
      {
        options: societeData.data.map((dataItem) => ({
          label: dataItem.label,
          value: dataItem.id,
        })),
      },
    ];
  };
  const getSociete = async () => {
    try {
      fetch(`https://www.fluxod.com/${api}/investisseurs/societes`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
        .then((response) => response.json())
        .then((societe) => {
          setSocieteData(societe);
        });
    } catch (error) {
      console.log(error);
    }
  };
  /*************************   Personne physique *******************************/
  const [pPData, setPpData] = useState({ data: [] });
  const [selectedPersonnePhysique, setSelectedPp] = useState("");
  const handlePersonneChange = (e) => {
    setSelectedPp(e);
  };
  const getPP = async (key) => {
    try {
      fetch(
        `https://www.fluxod.com/${api}/partenaires_exploitants/contacts?key=${key}`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
        .then((response) => response.json())
        .then((pp) => {
          setPpData(pp);
        });
    } catch (error) {
      console.log(error);
    }
  };
  const renderPpOptions = () => {
    return [
      {
        options: pPData.data.map((dataItem) => ({
          label: dataItem.label,
          value: dataItem.id,
        })),
      },
    ];
  };
  /*************************   Personne Morale *******************************/
  const [pMData, setPmData] = useState({ data: [] });
  const [selectedPm, setSelectedPm] = useState("");
  const handlePmChange = (e) => {
    setSelectedPm(e);
  };
  const getPM = async () => {
    try {
      fetch(
        `https://www.fluxod.com/${api}/partenaires_exploitants/societes?key=${value1}`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
        .then((response) => response.json())
        .then((pp) => {
          setPmData(pp);
        });
    } catch (error) {
      console.log(error);
    }
  };
  const renderPmOptions = () => {
    return [
      {
        options: pMData.data.map((dataItem) => ({
          label: dataItem.label,
          value: dataItem.id,
        })),
      },
    ];
  };
  /*************************   Type Personne *******************************/
  const [TypePersonneData, setTypePersonneData] = useState({ data: [] });
  const [selectedTypePersonne, setSelectedTypePersonne] = useState("");
  const handleTypePersonneChange = (e) => {
    setSelectedTypePersonne(e);
  };
  const getTypePersonne = async () => {
    try {
      fetch(
        `https://www.fluxod.com/${api}/partenaires_exploitants/type_personnes`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
        .then((response) => response.json())
        .then((pp) => {
          setTypePersonneData(pp);
        });
    } catch (error) {
      console.log(error);
    }
  };
  const renderTypePersonneOptions = () => {
    return [
      {
        options: TypePersonneData.data.map((dataItem) => ({
          label: dataItem.label,
          value: dataItem.id,
        })),
      },
    ];
  };

  /*************************   Taux d'apport  *******************************/
  const [tauxData, setTauxData] = useState({ data: [] });
  const [selectedTaux, setSelectedTaux] = useState("");
  const handleTauxChange = (e) => {
    setSelectedTaux(e);
  };
  const getTaux = async () => {
    try {
      fetch(
        `https://www.fluxod.com/${api}/partenaires_exploitants/taux_apports`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
        .then((response) => response.json())
        .then((data) => {
          setTauxData(data);
        });
    } catch (error) {
      console.log(error);
    }
  };
  const renderTauxOptions = () => {
    return [
      {
        options: tauxData.data.map((dataItem) => ({
          label: dataItem.label,
          value: dataItem.id,
        })),
      },
    ];
  };
  /*************************   Modèle dossier de souscription & TEPA  *******************************/
  const [modeleData, setModeleData] = useState({ data: [] });
  const [selectedModele, setSelectedModele] = useState("");
  const handleModeleChange = (e) => {
    setSelectedModele(e);
  };
  const [selectedModeleT, setSelectedModeleT] = useState("");
  const handleModeleTChange = (e) => {
    setSelectedModeleT(e);
  };
  const getModele = async () => {
    try {
      fetch(
        `https://www.fluxod.com/${api}/partenaires_exploitants/publipostages
`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
        .then((response) => response.json())
        .then((data) => {
          setModeleData(data);
        });
    } catch (error) {
      console.log(error);
    }
  };
  const renderModeleOptions = () => {
    return [
      {
        options: modeleData.data.map((dataItem) => ({
          label: dataItem.label,
          value: dataItem.id,
        })),
      },
    ];
  };
  /*************************   Type de productions  *******************************/
  const [typeProductionData, setTypeProductionData] = useState({ data: [] });
  const [selectedTypeProduction, setSelectedTypeProduction] = useState([]);
  const handleTypeProductionChange = (e) => {
    setSelectedTypeProduction(e);
    console.log(selectedTypeProduction);
  };
  const getTypeProduction = async () => {
    try {
      fetch(
        `https://www.fluxod.com/${api}/partenaires_exploitants/types_de_productions
`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
        .then((response) => response.json())
        .then((data) => {
          setTypeProductionData(data);
        });
    } catch (error) {
      console.log(error);
    }
  };
  const renderTypeProductionOptions = () => {
    return [
      {
        options: typeProductionData.data.map((dataItem) => ({
          label: dataItem.label,
          value: dataItem.id,
        })),
      },
    ];
  };
  /*************************   Annee   *******************************/
  const [selectedAnnee, setSelectedAnnee] = useState("");
  const [anneeData, setAnneeData] = useState({ data: [] });
  const handleAnneeChange = (e) => {
    setSelectedAnnee(e);
  };
  const getAnnee = async () => {
    try {
      fetch(`https://www.fluxod.com/${api}/partenaires_exploitants/annees`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
        .then((response) => response.json())
        .then((annee) => {
          setAnneeData(annee);
        });
    } catch (error) {
      console.log(error);
    }
  };
  const renderAnneeOptions = () => {
    return [
      <option key="" value=""></option>,
      ...anneeData.data.map((dataItem) => (
        <option key={dataItem.id} value={dataItem.id}>
          {dataItem.label}
        </option>
      )),
    ];
  };
  /******************************* HMF DonneesFinanciere *******************************************/
  const [formDonneesFinanciere, setFormDonneesFinanciere] = useState([]);

  const onAddFormDonneesFinanciere = () => {
    const modifiedDonneesFinanciere = [...formDonneesFinanciere];
    console.log(modifiedDonneesFinanciere);
    modifiedDonneesFinanciere.push({
      index: modifiedDonneesFinanciere.length + 1,
      id: null,
      annee_id: null,
      capitaux_propres: null,
      produits_exploitation: null,
      charges_exploitation: null,
      resultat_exploitation: null,
    });
    console.log(modifiedDonneesFinanciere);
    setFormDonneesFinanciere(modifiedDonneesFinanciere);
  };

  const onDeleteFormDonneesFinanciere = (id) => {
    var modifiedDonneesFinanciere = [...formDonneesFinanciere];
    modifiedDonneesFinanciere = modifiedDonneesFinanciere.filter(
      (x) => x["index"] !== id
    );
    setFormDonneesFinanciere(modifiedDonneesFinanciere);
  };
  const handleInputFinanceChange = (index, field, value) => {
    const modifiedDonneesFinanciere = formDonneesFinanciere.map((donnes) => {
      if (donnes.index === index) {
        return {
          ...donnes,
          [field]: value,
        };
      }
      return donnes;
    });

    setFormDonneesFinanciere(modifiedDonneesFinanciere);
    console.log(modifiedDonneesFinanciere);
  };
  /******************************* END HMF DonneesFinanciere *******************************************/
  /******************************* HMF DonneesInvest *******************************************/
  const [formDonneesInvest, setFormDonneesInvest] = useState([]);

  const onAddFormDonneesInvest = () => {
    const modifiedDonneesInvest = [...formDonneesInvest];
    console.log(modifiedDonneesInvest);
    modifiedDonneesInvest.push({
      index: modifiedDonneesInvest.length + 1,
      id: null,
      annee_id: null,
      designation: null,
      base_eligible: null,
      monteur: null,
    });
    console.log(modifiedDonneesInvest);
    setFormDonneesInvest(modifiedDonneesInvest);
  };

  const onDeleteFormDonneesInvest = (id) => {
    var modifiedDonneesInvest = [...formDonneesInvest];
    modifiedDonneesInvest = modifiedDonneesInvest.filter(
      (x) => x["index"] !== id
    );
    setFormDonneesInvest(modifiedDonneesInvest);
  };
  const handleInputInvestChange = (index, field, value) => {
    const modifiedDonneesInvest = formDonneesInvest.map((donnes) => {
      if (donnes.index === index) {
        return {
          ...donnes,
          [field]: value,
        };
      }
      return donnes;
    });

    setFormDonneesInvest(modifiedDonneesInvest);
    console.log(modifiedDonneesInvest);
  };
  /******************************* END HMF DonneesInvest *******************************************/
  /************************************* Select Oui Non  *********************************/
  const OuiNon = {
    data: [
      { id: 1, label: "Oui" },
      { id: 2, label: "Non" },
    ],
  };
  const renderOuiNonOptions = () => {
    return [
      {
        options: OuiNon.data.map((dataItem) => ({
          label: dataItem.label,
          value: dataItem.id,
        })),
      },
    ];
  };
  /************************************* Numero RCS *********************************/
  const [selectedNumero, setSelectedNumero] = useState("");
  const handleNumeroChange = (e) => {
    setSelectedNumero(e.target.value);
  };
  /************************************* Code RCS *********************************/
  const [selectedCode, setSelectedCode] = useState("");
  const handleCodeChange = (e) => {
    setSelectedCode(e.target.value);
  };
  /************************************* Actif *********************************/
  const [selectedActif, setSelectedActif] = useState("");
  const handleActifChange = (e) => {
    setSelectedActif(e);
  };
  /************************************* Défaut *********************************/
  const [selectedDefaut, setSelectedDefaut] = useState("");
  const handleDefautChange = (e) => {
    setSelectedDefaut(e);
  };
  /************************************* Trigramme *********************************/
  const [selectedTrigramme, setSelectedTrigramme] = useState("");
  const handleTrigrammeChange = (e) => {
    setSelectedTrigramme(e.target.value);
  };
  /************************************* Origine *********************************/
  const [selectedOrigine, setSelectedOrigine] = useState("");
  const handleOrigineChange = (e) => {
    setSelectedOrigine(e.target.value);
  };
  /************************************* Compte de créance *********************************/
  const [selectedCompteCreance, setSelectedCompteCreance] = useState("");
  const handleCompteCreanceChange = (e) => {
    setSelectedCompteCreance(e.target.value);
  };
  /************************************* Entrepreteurs *********************************/
  const [selectedEntrepreteur, setSelectedEntrepreteur] = useState("");
  const handleEntrepreteurChange = (e) => {
    setSelectedEntrepreteur(e);
  };
  const [selectedComptable, setSelectedComptable] = useState("");
  const handleComptableChange = (e) => {
    setSelectedComptable(e);
  };
  const [contactData, setContactData] = useState({ data: [] });

  const getContactData = async () => {
    try {
      fetch(`https://www.fluxod.com/${api}/partenaires_exploitants/contacts2`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
        .then((response) => response.json())
        .then((pp) => {
          setContactData(pp);
        });
    } catch (error) {
      console.log(error);
    }
  };
  const renderContactOptions = () => {
    return [
      {
        options: contactData.data.map((dataItem) => ({
          label: dataItem.label,
          value: dataItem.id,
        })),
      },
    ];
  };
  const [selectedDataCrea, setSelectedDateCrea] = useState("");
  const handleDataCreaChange = (e) => {
    setSelectedDateCrea(e.target.value);
  };
  const [selectedDateEntree, setSelectedDateEntree] = useState("");
  const handleDateEntreeChange = (e) => {
    setSelectedDateEntree(e.target.value);
  };

  const [selectedImpact, setSelectedImpact] = useState("");
  const handleImpactChange = (e) => {
    setSelectedImpact(e.target.value);
  };

  const [selectedMat, setSelectedMat] = useState("");
  const handleMatChange = (e) => {
    setSelectedMat(e.target.value);
  };

  const [selectedSecteur, setSelectedSecteur] = useState("");
  const handleSecteurChange = (e) => {
    setSelectedSecteur(e.target.value);
  };

  const [selectedSurfaceCons, setSelectedSurfaceCons] = useState("");
  const handleSurfaceConsChange = (e) => {
    setSelectedSurfaceCons(e.target.value);
  };

  const [selectedSurfaceExp, setSelectedSurfaceExp] = useState("");
  const handleSurfaceExpChange = (e) => {
    setSelectedSurfaceExp(e.target.value);
  };

  const [selectedSurfaceTot, setSelectedSurfaceTot] = useState("");
  const handleSurfaceTotChange = (e) => {
    setSelectedSurfaceTot(e.target.value);
  };
  /*************************   Secteur Activite   *******************************/
  const [selectedSecteurActivite, setSelectedSecteurActivite] = useState(null);
  const [secteurData, setSecteurActiviteData] = useState({ data: [] });
  const handleSecteurActiviteChange = (e) => {
    setSelectedSecteurActivite(e);
    getValue(e);
  };
  const getSecteurActivite = async () => {
    try {
      fetch(`https://www.fluxod.com/${api}/partenaires_exploitants/secteurs`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
        .then((response) => response.json())
        .then((annee) => {
          setSecteurActiviteData(annee);
        });
    } catch (error) {
      console.log(error);
    }
  };
  const renderSecteurActiviteOptions = () => {
    return [
      {
        options: secteurData.data.map((dataItem) => ({
          label: dataItem.label,
          value: dataItem.id,
        })),
      },
    ];
  };
  /************************* Update value *******************************/
  const debouncedValueChanged = useDebounce(selectedCode, 2000);
  const [fetchedData, setFetchedData] = useState(null);
  console.log(debouncedValueChanged);
  const getValue = async (e) => {
    var url;

    try {
      if (e != null) {
        url = `https://www.fluxod.com/${api}/partenaires_exploitants/update_values?secteur_activite_id=${
          e?.value || ""
        }`;
      } else {
        url = `https://www.fluxod.com/${api}/partenaires_exploitants/update_values?code_ape=${debouncedValueChanged}`;
      }
      const response = await fetch(url, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (!response.ok) {
        throw new Error("Network response was not ok");
      }

      const data = await response.json();
      setFetchedData(data);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (selectedCode != "" || selectedSecteurActivite != null) {
      getValue();
    }
  }, [debouncedValueChanged]);

  useEffect(() => {
    if (fetchedData) {
      setSelectedSecteur(fetchedData?.sil_secteur);

      if (fetchedData?.secteur_activite_id) {
        setSelectedSecteurActivite(fetchedData?.secteur_activite_id);
      }

      setSelectedCode(fetchedData?.code_ape);
    }
    setForceRender2(!forceRender2);
    setForceRender3(!forceRender3);
  }, [fetchedData]);
  /******************************* Submit  *******************************************/
  const handleSubmitPm = async (event) => {
    event.preventDefault();
    if (selectedPm === null) {
      toast.error("Personne morale ne peut pas être vide");
    } else if (selectedType === null) {
      toast.error("Type ne peut pas être vide");
    } else if (selectedTypePersonne === null) {
      toast.error("Type personne ne peut pas être vide");
    } else {
      try {
        const response = await fetch(
          `https://www.fluxod.com/${api}/partenaires_exploitants`,
          {
            method: "POST",
            headers: {
              Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify({
              partenaire: {
                id: id,
                type_personne_id: selectedTypePersonne?.value,
                societe_id: selectedPm?.value,
                defaut: selectedDefaut?.value,
                types_partenaire_id: selectedType?.value,
                rcs: selectedNumero,
                code_ape: selectedCode,
                actif: selectedActif?.value,
                trigramme: selectedTrigramme,
                //partenaire_id: selectedTeteReseau?.value,
                ///
                // origine: selectedOrigine,
                // taux_apport_id: selectedTaux.map((item) => item.value),
                // publipostage_id: selectedModele?.value,
                // publipostage2_id: selectedModeleT?.value,
                entrepreteurs: selectedEntrepreteur?.value,
                ///
                compte_de_creance: selectedCompteCreance,
                ///
                contact2_id: selectedComptable?.value,
                impact_sur_lemploi: selectedImpact,
                date_creation_activite: selectedDataCrea,
                surface_totale_detenue: selectedSurfaceTot,
                surface_exploitee: selectedSurfaceExp,
                surface_construite: selectedSurfaceCons,
                materiel_dexploitation: selectedMat,
                date_relation: selectedDateEntree,
                secteur_dactivite_de_lexploitant: selectedSecteur,
                secteur_activite_id: selectedSecteurActivite?.value || "",
                types_de_production_id:
                  selectedTypeProduction?.map((item) => item.value) || "",
              },
              hmf_donnees_exploitants: formDonneesFinanciere.map((obj) => {
                delete obj.index;
                return obj;
              }),
              hmf_donnees_investissements: formDonneesInvest.map((obj) => {
                delete obj.index;
                return obj;
              }),
            }),
          }
        );

        if (response.ok) {
          console.log("POST request successful");
          const responseData = await response.json();
          navigate(`${backUrl}/partenaires_exploitants/${responseData.id}`);
          // handleNavigate({ key: true });
        } else {
          console.error("POST request failed");
          const responseData = await response.json();
          if (responseData && responseData.partenaire_validation) {
            // Si le champ "societe_validation" est présent dans la réponse JSON
            const errors = responseData?.partenaire_validation;

            errors.forEach((error) => {
              toast.error(error);
            });
          } else {
            toast.error("Une erreur s'est produite");
          }
        }
      } catch (error) {
        console.error("An error occurred", error);
        toast.error("Une erreur s'est produite ?");
      }
    }
  };
  const handleSubmitP = async (event) => {
    event.preventDefault();
    if (selectedPm === null) {
      toast.error("Personne morale ne peut pas être vide");
    } else if (selectedType === null) {
      toast.error("Type ne peut pas être vide");
    } else if (selectedTypePersonne === null) {
      toast.error("Type personne ne peut pas être vide");
    } else {
      try {
        const response = await fetch(
          `https://www.fluxod.com/${api}/partenaires_exploitants`,
          {
            method: "POST",
            headers: {
              Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify({
              partenaire: {
                id: id,
                type_personne_id: selectedTypePersonne?.value,

                contact_id: selectedPersonnePhysique?.value,
                defaut: selectedDefaut?.value,
                types_partenaire_id: selectedType?.value,
                rcs: selectedNumero,
                code_ape: selectedCode,
                actif: selectedActif?.value,
                trigramme: selectedTrigramme,
                // partenaire_id: selectedTeteReseau?.value,
                ///
                // origine: selectedOrigine,
                // taux_apport_id: selectedTaux.map((item) => item.value),
                // publipostage_id: selectedModele?.value,
                // publipostage2_id: selectedModeleT?.value,
                entrepreteurs: selectedEntrepreteur?.value,
                ///
                compte_de_creance: selectedCompteCreance,
                ///
                contact2_id: selectedComptable?.value,
                impact_sur_lemploi: selectedImpact,
                date_creation_activite: selectedDataCrea,
                surface_totale_detenue: selectedSurfaceTot,
                surface_exploitee: selectedSurfaceExp,
                surface_construite: selectedSurfaceCons,
                materiel_dexploitation: selectedMat,
                secteur_dactivite_de_lexploitant: selectedSecteur,
                secteur_activite_id: selectedSecteurActivite?.value || "",
                date_relation: selectedDateEntree,
                types_de_production_id: selectedTypeProduction.map(
                  (item) => item.value
                ),
              },
              hmf_donnees_exploitants: formDonneesFinanciere.map((obj) => {
                delete obj.index;
                return obj;
              }),
              hmf_donnees_investissements: formDonneesInvest.map((obj) => {
                delete obj.index;
                return obj;
              }),
            }),
          }
        );

        if (response.ok) {
          console.log("POST request successful");
          const responseData = await response.json();
          localStorage.setItem("key", true);

          navigate(`${backUrl}/partenaires_exploitants/${responseData.id}`);
          // handleNavigate({ key: true });
        } else {
          console.error("POST request failed");
          const responseData = await response.json();
          if (responseData && responseData.partenaire_validation) {
            // Si le champ "societe_validation" est présent dans la réponse JSON
            const errors = responseData?.partenaire_validation;

            errors.forEach((error) => {
              toast.error(error);
            });
          } else {
            toast.error("Une erreur s'est produite");
          }
        }
      } catch (error) {
        console.error("An error occurred", error);
        toast.error("Une erreur s'est produite");
      }
    }
  };
  const handleNavigate = () => {
    localStorage.setItem("key", true);
    navigate(-1);
  };

  /******************************* END Validation *******************************************/
  useEffect(() => {
    if (!loading) {
      getType();
      // getPP();
      getTypePersonne();
      // getPM();
      getSecteurActivite();
      getTaux();
      getModele();
      getTypeProduction();
      getAnnee();
      getPay();
      getTitre();
      getContactData();
      getSociete();
      getSituationMatrimoniale();
    }
  }, [loading]);
  useEffect(() => {
    if (value.length > 1) {
      getPP(value);
    }
  }, [loading, value]);
  useEffect(() => {
    if (value1.length > 1) {
      getPM(value1);
    }
  }, [loading, value1]);
  const handleTabClick = (tab) => {
    setActiveTab(tab); // Mettre à jour l'état lors du clic sur un onglet
  };
  document.title = "New Exploitant agricole | Edit";
  const CustomNavTabs = () => {
    const navStyle = {
      cursor: "pointer",
      borderRadius: "0px",
      whiteSpace: "nowrap",
    };
    return (
      <Nav pills className="navtab-bg nav-justified custom-nav-tabs">
        <NavItem>
          <NavLink
            style={navStyle}
            className={`nav-link ${activeTab === "details" ? "active" : ""}`}
            to="#details"
            onClick={() => handleTabClick("details")}
          >
            Détails
          </NavLink>
        </NavItem>
      </Nav>
    );
  };

  return (
    <>
      <React.Fragment>
        <div className="page-content" style={{ fontFamily: "sans-serif" }}>
          <div className="container-fluid">
            <Row>
              <Col lg="12">
                <Card>
                  <CardBody className="border-bottom">
                    <div className="d-flex align-items-center">
                      <h5
                        className="mb-0 card-title flex-grow-1"
                        style={{ fontWeight: "bold", display: "flex" }}
                      >
                        <Link
                          to={`${backUrl}/partenaires_exploitants/`}
                          style={{
                            color: "#555B21",
                            textDecoration: "underline !important",
                          }}
                        >
                          Exploitant agricole
                        </Link>{" "}
                        <i className="bx bx-caret-right"></i>{" "}
                        {!loading ? (
                          cgpData.sil
                        ) : (
                          <>
                            <span
                              className="placeholder col-3"
                              style={{ height: "1em" }}
                            ></span>
                          </>
                        )}
                      </h5>
                    </div>

                    <div className="d-flex justify-content-end">
                      <div className="d-flex align-items-end">
                        <button
                          className="btn btn-sm btn-primary"
                          onClick={
                            selectedTypePersonne?.label == "PP"
                              ? handleSubmitP
                              : handleSubmitPm
                          }
                        >
                          <i className="bx bx-send"></i> Créer
                        </button>
                        &nbsp; &nbsp;
                        <Link
                          to={`${backUrl}/partenaires_exploitants/`}
                          className="btn btn-sm btn-soft-secondary "
                          style={{ width: "88.43px" }}
                        >
                          <i className="bx bx-arrow-back"></i> Annuler
                        </Link>
                      </div>
                    </div>
                  </CardBody>
                  {CustomNavTabs()}
                  <CardBody>
                    {activeTab === "details" && (
                      <div>
                        {!loading ? (
                          <>
                            <Row>
                              <Col sm="6">
                                <Card className="mb-4">
                                  <CardTitle
                                    tag="h5"
                                    style={{ paddingLeft: "10px" }}
                                  >
                                    Identification
                                  </CardTitle>
                                  <CardBody>
                                    <Row className="mb-2">
                                      <Col
                                        xs={12}
                                        md={12}
                                        lg={4}
                                        style={colStyle}
                                      >
                                        <i style={{ color: "#9d9c9c" }}>
                                          <span>Type personne* :</span>
                                        </i>
                                      </Col>
                                      <Col className="col-md-6">
                                        <Select
                                          placeholder="Séléctionner Type personne"
                                          defaultValue={selectedTypePersonne}
                                          onChange={handleTypePersonneChange}
                                          options={renderTypePersonneOptions()}
                                          isClearable={true}
                                          className="select2"
                                          styles={styles(
                                            selectedTypePersonne == null
                                          )}
                                        />
                                        {selectedTypePersonne === null ? (
                                          <div
                                            style={{
                                              color: "red",
                                              whiteSpace: "nowrap",
                                            }}
                                          >
                                            Type personne ne peut pas être vide
                                          </div>
                                        ) : (
                                          ""
                                        )}
                                      </Col>
                                    </Row>
                                    {selectedTypePersonne?.label == "PP" ? (
                                      <>
                                        <Row className="mb-2">
                                          <Col
                                            xs={12}
                                            md={12}
                                            lg={4}
                                            style={colStyle}
                                          >
                                            <i style={{ color: "#9d9c9c" }}>
                                              <span>Personne Physique* :</span>
                                            </i>
                                          </Col>
                                          <Col className="col-md-6 d-flex align-items-center">
                                            <Select
                                              key={forceRender1}
                                              onInputChange={handleValueChange}
                                              defaultValue={
                                                selectedPersonnePhysique
                                              }
                                              placeholder="Taper pour rechercher ..."
                                              onChange={handlePersonneChange}
                                              options={renderPpOptions()}
                                              isClearable={true}
                                              className="select2 flex-grow-1"
                                              styles={styles(false)}
                                            />
                                            <Button
                                              onClick={toggleModal1}
                                              className="btn btn-sm btn-light ms-2"
                                            >
                                              +
                                            </Button>
                                          </Col>
                                          {selectedPersonnePhysique === null ? (
                                            <div
                                              style={{
                                                color: "red",
                                                whiteSpace: "nowrap",
                                              }}
                                            >
                                              Personne physique ne peut pas être
                                              vide
                                            </div>
                                          ) : (
                                            ""
                                          )}
                                          <Modal
                                            isOpen={modalOpen1}
                                            toggle={toggleModal1}
                                          >
                                            <ModalHeader toggle={toggleModal1}>
                                              Ajouter une nouvelle personne
                                              physique
                                            </ModalHeader>
                                            <ModalBody>
                                              <Row className="mb-2">
                                                <Col md={6}>
                                                  <label>Nom</label>
                                                  <input
                                                    type="text"
                                                    value={nom}
                                                    onChange={(e) =>
                                                      setNom(e.target.value)
                                                    }
                                                    className="form-control"
                                                  />
                                                </Col>
                                                <Col md={6}>
                                                  <label>Prénom</label>
                                                  <input
                                                    type="text"
                                                    value={prenom}
                                                    onChange={(e) =>
                                                      setPrenom(e.target.value)
                                                    }
                                                    className="form-control"
                                                  />
                                                </Col>
                                              </Row>
                                              <Row className="mb-2">
                                                <Col md={6}>
                                                  <label>Titre</label>
                                                  <Select
                                                    placeholder="Selectionner un titre"
                                                    defaultValue={
                                                      titreId?.label == null
                                                        ? null
                                                        : titreId
                                                    }
                                                    onChange={
                                                      handleTitreIdChange
                                                    }
                                                    options={renderTitreOptions()}
                                                    isClearable={true}
                                                    className="select2 flex-grow-1"
                                                    styles={{
                                                      menu: (
                                                        provided,
                                                        state
                                                      ) => ({
                                                        ...provided,
                                                        backgroundColor:
                                                          "white",
                                                      }),
                                                    }}
                                                  />
                                                </Col>
                                                <Col md={6}>
                                                  <label>Société</label>
                                                  <Select
                                                    placeholder="Selectionner une societe"
                                                    defaultValue={
                                                      titreId?.label == null
                                                        ? null
                                                        : titreId
                                                    }
                                                    onChange={
                                                      handleSocieteChange
                                                    }
                                                    options={renderSocieteOptions()}
                                                    isClearable={true}
                                                    className="select2 flex-grow-1"
                                                    styles={{
                                                      menu: (
                                                        provided,
                                                        state
                                                      ) => ({
                                                        ...provided,
                                                        backgroundColor:
                                                          "white",
                                                      }),
                                                    }}
                                                  />
                                                </Col>
                                              </Row>

                                              <Row className="mb-2">
                                                <Col md={6}>
                                                  <label>
                                                    Date de naissance
                                                  </label>
                                                  <InputMask
                                                    mask="99/99/9999"
                                                    value={dateDeNaissance}
                                                    onChange={(e) =>
                                                      setDateDeNaissance(
                                                        e.target.value
                                                      )
                                                    }
                                                    className="form-control"
                                                    placeholder="JJ/MM/AAAA"
                                                  />
                                                </Col>
                                                <Col md={6}>
                                                  <label>
                                                    Ville de naissance
                                                  </label>
                                                  <input
                                                    type="text"
                                                    value={villeDeNaissance}
                                                    onChange={(e) =>
                                                      setVilleDeNaissance(
                                                        e.target.value
                                                      )
                                                    }
                                                    className="form-control"
                                                  />
                                                </Col>
                                              </Row>
                                              <Row className="mb-2">
                                                <Col md={6}>
                                                  <label>
                                                    Departement de naissance
                                                  </label>
                                                  <input
                                                    type="text"
                                                    value={departementOuPays}
                                                    onChange={(e) =>
                                                      setDepartementOuPays(
                                                        e.target.value
                                                      )
                                                    }
                                                    className="form-control"
                                                  />
                                                </Col>
                                                <Col md={6}>
                                                  <label>Profession</label>
                                                  <input
                                                    type="text"
                                                    value={profession}
                                                    onChange={(e) =>
                                                      setProfession(
                                                        e.target.value
                                                      )
                                                    }
                                                    className="form-control"
                                                  />
                                                </Col>
                                              </Row>
                                              <Row className="mb-2">
                                                <Col md={6}>
                                                  <label>
                                                    Situation matrimoniale
                                                  </label>
                                                  <Select
                                                    placeholder="Selectionner situtation matrimoniale"
                                                    defaultValue={
                                                      titreId?.label == null
                                                        ? null
                                                        : titreId
                                                    }
                                                    onChange={
                                                      handleSituationMatrimonialChange
                                                    }
                                                    options={renderSituationMatrimonialOptions()}
                                                    isClearable={true}
                                                    className="select2 flex-grow-1"
                                                    styles={{
                                                      menu: (
                                                        provided,
                                                        state
                                                      ) => ({
                                                        ...provided,
                                                        backgroundColor:
                                                          "white",
                                                      }),
                                                    }}
                                                  />
                                                </Col>
                                                <Col md={6}>
                                                  <label>Adresse</label>
                                                  <input
                                                    type="text"
                                                    value={adresse1}
                                                    onChange={(e) =>
                                                      setAdresse1(
                                                        e.target.value
                                                      )
                                                    }
                                                    className="form-control"
                                                  />
                                                </Col>
                                              </Row>
                                              <Row className="mb-2">
                                                <Col md={6}>
                                                  <label>Complément</label>
                                                  <input
                                                    type="text"
                                                    value={complement}
                                                    onChange={(e) =>
                                                      setComplement(
                                                        e.target.value
                                                      )
                                                    }
                                                    className="form-control"
                                                  />
                                                </Col>
                                                <Col md={6}>
                                                  <label>Code postal</label>
                                                  <input
                                                    type="text"
                                                    value={codePostal1}
                                                    onChange={(e) =>
                                                      setCodePostal1(
                                                        e.target.value
                                                      )
                                                    }
                                                    className="form-control"
                                                  />
                                                </Col>
                                              </Row>
                                              <Row className="mb-2">
                                                <Col md={6}>
                                                  <label>Ville</label>
                                                  <input
                                                    type="text"
                                                    value={ville1}
                                                    onChange={(e) =>
                                                      setVille1(e.target.value)
                                                    }
                                                    className="form-control"
                                                  />
                                                </Col>
                                                <Col md={6}>
                                                  <label>Pays</label>
                                                  <Select
                                                    placeholder="Sélectionner un pays"
                                                    defaultValue={
                                                      payId1?.label == null
                                                        ? null
                                                        : payId1
                                                    }
                                                    onChange={handlePayIdChange}
                                                    options={renderPaysOptions()}
                                                    styles={{
                                                      menu: (
                                                        provided,
                                                        state
                                                      ) => ({
                                                        ...provided,
                                                        backgroundColor:
                                                          "white",
                                                      }),
                                                    }}
                                                    isClearable={true}
                                                    className="select2"
                                                  />{" "}
                                                </Col>
                                              </Row>
                                              <Row className="mb-2">
                                                <Col md={6}>
                                                  <label>
                                                    Email professionnel
                                                  </label>
                                                  <input
                                                    type="email"
                                                    value={emailPro}
                                                    onChange={(e) =>
                                                      setEmailPro(
                                                        e.target.value
                                                      )
                                                    }
                                                    className="form-control"
                                                  />
                                                </Col>
                                                <Col md={6}>
                                                  <label>Email perso</label>
                                                  <input
                                                    type="email"
                                                    value={emailPerso}
                                                    onChange={(e) =>
                                                      setEmailPerso(
                                                        e.target.value
                                                      )
                                                    }
                                                    className="form-control"
                                                  />
                                                  {emailPerso?.trim() ===
                                                    "" && (
                                                    <div
                                                      style={{
                                                        color: "red",
                                                        fontSize: "12px",
                                                        marginTop: "5px",
                                                      }}
                                                    >
                                                      Ce champ est obligatoire.
                                                    </div>
                                                  )}
                                                </Col>
                                              </Row>
                                              <Row className="mb-2">
                                                <Col md={6}>
                                                  <label>
                                                    Téléphone mobile
                                                  </label>
                                                  <input
                                                    type="tel"
                                                    value={telMobil}
                                                    onChange={(e) =>
                                                      setTelMobil(
                                                        e.target.value
                                                      )
                                                    }
                                                    className="form-control"
                                                    required
                                                  />
                                                  {telMobil?.trim() === "" && (
                                                    <div
                                                      style={{
                                                        color: "red",
                                                        fontSize: "12px",
                                                        marginTop: "5px",
                                                      }}
                                                    >
                                                      Ce champ est obligatoire.
                                                    </div>
                                                  )}
                                                </Col>
                                                <Col md={6}>
                                                  <label>Téléphone fixe</label>
                                                  <input
                                                    type="tel"
                                                    value={telFix}
                                                    onChange={(e) =>
                                                      setTelFix(e.target.value)
                                                    }
                                                    className="form-control"
                                                  />
                                                </Col>
                                              </Row>
                                            </ModalBody>
                                            <ModalFooter>
                                              <Button
                                                color="primary"
                                                onClick={handleSave1}
                                              >
                                                Enregistrer
                                              </Button>
                                              <Button
                                                color="secondary"
                                                onClick={toggleModal1}
                                              >
                                                Annuler
                                              </Button>
                                            </ModalFooter>
                                          </Modal>
                                        </Row>
                                      </>
                                    ) : selectedTypePersonne?.label == "PM" ? (
                                      <Row className="mb-2">
                                        <Col
                                          xs={12}
                                          md={12}
                                          lg={4}
                                          style={colStyle}
                                        >
                                          <i style={{ color: "#9d9c9c" }}>
                                            <span>Personne Morale :</span>
                                          </i>
                                        </Col>
                                        <Col className="col-md-6 d-flex align-items-center">
                                          <Select
                                            key={forceRender}
                                            placeholder="Taper pour rechercher ..."
                                            onInputChange={handleValue1Change}
                                            defaultValue={selectedPm}
                                            onChange={handlePmChange}
                                            options={renderPmOptions()}
                                            isClearable={true}
                                            className="select2 flex-grow-1"
                                            styles={styles(false)}
                                          />
                                          <Button
                                            onClick={toggleModal}
                                            className="btn btn-sm btn-light ms-2"
                                          >
                                            +
                                          </Button>
                                        </Col>
                                        <Modal
                                          isOpen={modalOpen}
                                          toggle={toggleModal}
                                        >
                                          <ModalHeader toggle={toggleModal}>
                                            Ajouter une nouvelle personne morale
                                          </ModalHeader>
                                          <ModalBody>
                                            <FormGroup>
                                              <Label for="raisonSociale">
                                                Raison sociale
                                              </Label>
                                              <Input
                                                type="text"
                                                name="raisonSociale"
                                                id="raisonSociale"
                                                value={raisonSociale}
                                                onChange={(e) =>
                                                  setRaisonSociale(
                                                    e.target.value
                                                  )
                                                }
                                              />
                                            </FormGroup>
                                            <FormGroup>
                                              <Label for="email">Email</Label>
                                              <Input
                                                type="email"
                                                name="email"
                                                id="email"
                                                value={email}
                                                onChange={(e) =>
                                                  setEmail(e.target.value)
                                                }
                                              />
                                            </FormGroup>
                                            <FormGroup>
                                              <Label for="telephone">
                                                Téléphone
                                              </Label>
                                              <Input
                                                type="text"
                                                name="telephone"
                                                id="telephone"
                                                value={telephone}
                                                onChange={(e) =>
                                                  setTelephone(e.target.value)
                                                }
                                              />
                                            </FormGroup>
                                            <FormGroup>
                                              <Label for="fax">Fax</Label>
                                              <Input
                                                type="text"
                                                name="fax"
                                                id="fax"
                                                value={fax}
                                                onChange={(e) =>
                                                  setFax(e.target.value)
                                                }
                                              />
                                            </FormGroup>
                                            <FormGroup>
                                              <Label for="adresse">
                                                Adresse
                                              </Label>
                                              <Input
                                                type="text"
                                                name="adresse"
                                                id="adresse"
                                                value={adresse}
                                                onChange={(e) =>
                                                  setAdresse(e.target.value)
                                                }
                                              />
                                            </FormGroup>
                                            <FormGroup>
                                              <Label for="codePostal">
                                                Code postal
                                              </Label>
                                              <Input
                                                type="text"
                                                name="codePostal"
                                                id="codePostal"
                                                value={codePostal}
                                                onChange={(e) =>
                                                  setCodePostal(e.target.value)
                                                }
                                              />
                                            </FormGroup>
                                            <FormGroup>
                                              <Label for="ville">Ville</Label>
                                              <Input
                                                type="text"
                                                name="ville"
                                                id="ville"
                                                value={ville}
                                                onChange={(e) =>
                                                  setVille(e.target.value)
                                                }
                                              />
                                            </FormGroup>
                                            <FormGroup>
                                              <Label for="payId">Pays</Label>
                                              <Select
                                                placeholder="Sélectionnez le pays"
                                                defaultValue={payId}
                                                onChange={setPayId}
                                                options={renderPaysOptions()}
                                                styles={{
                                                  menu: (provided, state) => ({
                                                    ...provided,
                                                    backgroundColor: "white",
                                                  }),
                                                }}
                                              />
                                            </FormGroup>
                                          </ModalBody>
                                          <ModalFooter>
                                            <Button
                                              color="primary"
                                              onClick={handleSave}
                                            >
                                              Enregistrer
                                            </Button>
                                            <Button
                                              color="secondary"
                                              onClick={toggleModal}
                                            >
                                              Annuler
                                            </Button>
                                          </ModalFooter>
                                        </Modal>
                                      </Row>
                                    ) : null}
                                    <Row className="mb-2">
                                      <Col
                                        xs={12}
                                        md={12}
                                        lg={4}
                                        style={colStyle}
                                      >
                                        <i style={{ color: "#9d9c9c" }}>
                                          <span>Type * :</span>
                                        </i>
                                      </Col>
                                      <Col className="col-md-6">
                                        <Select
                                          placeholder="Séléctionner Type"
                                          defaultValue={selectedType}
                                          onChange={handleTypeChange}
                                          options={renderTypeOptions()}
                                          isClearable={true}
                                          className="select2"
                                          styles={styles(selectedType == null)}
                                        />
                                        {selectedType === null ? (
                                          <div
                                            style={{
                                              color: "red",
                                              whiteSpace: "nowrap",
                                            }}
                                          >
                                            Type ne peut pas être vide
                                          </div>
                                        ) : (
                                          ""
                                        )}
                                      </Col>
                                    </Row>
                                    <Row className="mb-2">
                                      <Col
                                        xs={12}
                                        md={12}
                                        lg={4}
                                        style={colStyle}
                                      >
                                        <i style={{ color: "#9d9c9c" }}>
                                          <span>N° RCS :</span>
                                        </i>
                                      </Col>
                                      <Col className="col-md-6">
                                        <input
                                          className="form-control form-control-sm"
                                          defaultValue={selectedNumero}
                                          required
                                          onChange={handleNumeroChange}
                                        />
                                      </Col>
                                    </Row>
                                    <Row className="mb-2">
                                      <Col
                                        xs={12}
                                        md={12}
                                        lg={4}
                                        style={colStyle}
                                      >
                                        <i style={{ color: "#9d9c9c" }}>
                                          <span>Code APE :</span>
                                        </i>
                                      </Col>
                                      <Col className="col-md-6">
                                        <input
                                          key={forceRender2}
                                          className="form-control form-control-sm"
                                          defaultValue={selectedCode}
                                          required
                                          onChange={handleCodeChange}
                                        />
                                      </Col>
                                    </Row>
                                    <Row className="mb-2">
                                      <Col
                                        xs={12}
                                        md={12}
                                        lg={4}
                                        style={colStyle}
                                      >
                                        <i style={{ color: "#9d9c9c" }}>
                                          <span>Actif* :</span>
                                        </i>
                                      </Col>
                                      <Col className="col-md-6">
                                        <Select
                                          placeholder="Séléctionner Actif"
                                          defaultValue={selectedActif}
                                          onChange={handleActifChange}
                                          options={renderOuiNonOptions()}
                                          isClearable={true}
                                          className="select2"
                                          styles={styles(selectedActif == null)}
                                        />
                                        {selectedActif === null ? (
                                          <div
                                            style={{
                                              color: "red",
                                              whiteSpace: "nowrap",
                                            }}
                                          >
                                            Actif ne peut pas être vide
                                          </div>
                                        ) : (
                                          ""
                                        )}
                                      </Col>
                                    </Row>
                                    <Row className="mb-2">
                                      <Col
                                        xs={12}
                                        md={12}
                                        lg={4}
                                        style={colStyle}
                                      >
                                        <i style={{ color: "#9d9c9c" }}>
                                          <span>Défaut :</span>
                                        </i>
                                      </Col>
                                      <Col className="col-md-6">
                                        <Select
                                          placeholder="Séléctionner Défaut"
                                          defaultValue={selectedDefaut}
                                          onChange={handleDefautChange}
                                          options={renderOuiNonOptions()}
                                          isClearable={true}
                                          className="select2"
                                          styles={styles(false)}
                                        />
                                      </Col>
                                    </Row>
                                    <Row className="mb-2">
                                      <Col
                                        xs={12}
                                        md={12}
                                        lg={4}
                                        style={colStyle}
                                      >
                                        <i style={{ color: "#9d9c9c" }}>
                                          <span>Trigramme :</span>
                                        </i>
                                      </Col>
                                      <Col className="col-md-6">
                                        <input
                                          className="form-control form-control-sm"
                                          defaultValue={selectedTrigramme}
                                          required
                                          onChange={handleTrigrammeChange}
                                        />
                                      </Col>
                                    </Row>
                                    <Row className="mb-2">
                                      <Col
                                        xs={12}
                                        md={12}
                                        lg={4}
                                        style={colStyle}
                                      >
                                        <i style={{ color: "#9d9c9c" }}>
                                          <span>Date entrée en relation :</span>
                                        </i>
                                      </Col>
                                      <Col className="col-md-6">
                                        <InputMask
                                          mask="99/99/9999"
                                          value={selectedDateEntree}
                                          className="form-control form-control-sm input-color"
                                          onChange={handleDateEntreeChange}
                                        />
                                      </Col>
                                    </Row>
                                  </CardBody>
                                </Card>
                              </Col>

                              <Col sm="6">
                                <Card className="mb-4">
                                  <CardTitle
                                    tag="h5"
                                    style={{ paddingLeft: "10px" }}
                                  >
                                    {" "}
                                    Données complémentaires CGP
                                  </CardTitle>
                                  <CardBody>
                                    <Row className="mb-2">
                                      <Col
                                        xs={12}
                                        md={12}
                                        lg={4}
                                        style={colStyle}
                                      >
                                        <i style={{ color: "#9d9c9c" }}>
                                          <span>Entrepreteurs :</span>
                                        </i>
                                      </Col>
                                      <Col className="col-md-6">
                                        <Select
                                          placeholder="Séléctionner Entrepreteurs"
                                          defaultValue={selectedEntrepreteur}
                                          onChange={handleEntrepreteurChange}
                                          options={renderOuiNonOptions()}
                                          isClearable={true}
                                          className="select2"
                                          styles={styles(false)}
                                        />
                                      </Col>
                                    </Row>
                                  </CardBody>
                                </Card>
                                <Row>
                                  <Col sm="12">
                                    <Card className="mb-4">
                                      <CardTitle
                                        tag="h5"
                                        style={{ paddingLeft: "10px" }}
                                      >
                                        {" "}
                                        Données complémentaires Direction
                                        produit
                                      </CardTitle>
                                      <CardBody>
                                        <Row className="mb-2">
                                          <Col
                                            xs={12}
                                            md={12}
                                            lg={4}
                                            style={colStyle}
                                          >
                                            <i style={{ color: "#9d9c9c" }}>
                                              <span>Compte de créance :</span>
                                            </i>
                                          </Col>
                                          <Col className="col-md-6">
                                            <input
                                              className="form-control form-control-sm"
                                              defaultValue={
                                                selectedCompteCreance
                                              }
                                              required
                                              onChange={
                                                handleCompteCreanceChange
                                              }
                                            />
                                          </Col>
                                        </Row>
                                      </CardBody>
                                    </Card>
                                  </Col>
                                </Row>
                                <Row>
                                  <Col sm="12">
                                    <Card className="mb-4">
                                      <CardTitle
                                        tag="h5"
                                        style={{ paddingLeft: "10px" }}
                                      >
                                        {" "}
                                        Données complémentaires exploitant
                                      </CardTitle>

                                      <CardBody>
                                        {/* Matériel d'exploitation */}
                                        <Row className="mb-2">
                                          <Col
                                            xs={12}
                                            md={12}
                                            lg={4}
                                            style={colStyle}
                                          >
                                            <i style={{ color: "#9d9c9c" }}>
                                              <span>
                                                Matériel d'exploitation :
                                              </span>
                                            </i>
                                          </Col>
                                          <Col className="col-md-6">
                                            <input
                                              className="form-control form-control-sm"
                                              defaultValue={selectedMat}
                                              required
                                              onChange={handleMatChange}
                                            />
                                          </Col>
                                        </Row>
                                        {/* Comptable 
                                        <Row className="mb-2">
                                          <Col
                                            xs={12}
                                            md={12}
                                            lg={4}
                                            style={colStyle}
                                          >
                                            <i style={{ color: "#9d9c9c" }}>
                                              <span>Comptable :</span>
                                            </i>
                                          </Col>
                                          <Col className="col-md-6">
                                            <Select
                                              placeholder="Sélection du comptable"
                                              defaultValue={selectedComptable}
                                              onChange={handleComptableChange}
                                              options={renderContactOptions()}
                                              isClearable={true}
                                              className="select2"
                                              styles={styles(false)}
                                            />
                                          </Col>
                                        </Row>
                                        */}
                                        <Row className="mb-2">
                                          <Col
                                            xs={12}
                                            md={12}
                                            lg={4}
                                            style={colStyle}
                                          >
                                            <i style={{ color: "#9d9c9c" }}>
                                              <span>Types de production :</span>
                                            </i>
                                          </Col>
                                          <Col className="col-md-6">
                                            <Select
                                              placeholder="Séléctionner Type de production"
                                              defaultValue={
                                                selectedTypeProduction
                                              }
                                              onChange={
                                                handleTypeProductionChange
                                              }
                                              options={renderTypeProductionOptions()}
                                              isClearable={true}
                                              className="select2"
                                              isMulti={true}
                                              styles={styles(false)}
                                            />
                                          </Col>
                                        </Row>
                                        {/* Date création activité */}
                                        <Row className="mb-2">
                                          <Col
                                            xs={12}
                                            md={12}
                                            lg={4}
                                            style={colStyle}
                                          >
                                            <i style={{ color: "#9d9c9c" }}>
                                              <span>
                                                Date création activité :
                                              </span>
                                            </i>
                                          </Col>
                                          <Col className="col-md-6">
                                            <InputMask
                                              mask="99/99/9999"
                                              value={selectedDataCrea}
                                              className="form-control form-control-sm input-color"
                                              onChange={handleDataCreaChange}
                                            />
                                          </Col>
                                        </Row>
                                        {/* Secteur d'activité de l'exploitant */}
                                        <Row className="mb-2">
                                          <Col
                                            xs={12}
                                            md={12}
                                            lg={4}
                                            style={colStyle}
                                          >
                                            <i style={{ color: "#9d9c9c" }}>
                                              <span>
                                                Secteur d'activité de
                                                l'exploitant :
                                              </span>
                                            </i>
                                          </Col>
                                          <Col className="col-md-6">
                                            <input
                                              className="form-control form-control-sm"
                                              defaultValue={selectedSecteur}
                                              required
                                              onChange={handleSecteurChange}
                                            />
                                          </Col>
                                        </Row>
                                        <Row className="mb-2">
                                          <Col
                                            xs={12}
                                            md={12}
                                            lg={4}
                                            style={colStyle}
                                          >
                                            <i
                                              style={{
                                                color: "#9d9c9c",
                                              }}
                                            >
                                              <span>Secteur d'activité :</span>
                                            </i>
                                          </Col>
                                          <Col className="col-md-6">
                                            <Select
                                              key={forceRender3}
                                              placeholder="Séléctionner"
                                              defaultValue={
                                                selectedSecteurActivite
                                              }
                                              onChange={
                                                handleSecteurActiviteChange
                                              }
                                              options={renderSecteurActiviteOptions()}
                                              isClearable={true}
                                              className="select2"
                                              styles={styles(false)}
                                            />
                                          </Col>
                                        </Row>

                                        {/* Surface construite (m²) */}
                                        <Row className="mb-2">
                                          <Col
                                            xs={12}
                                            md={12}
                                            lg={4}
                                            style={colStyle}
                                          >
                                            <i style={{ color: "#9d9c9c" }}>
                                              <span>
                                                Surface construite (m²) :
                                              </span>
                                            </i>
                                          </Col>
                                          <Col className="col-md-6">
                                            <input
                                              className="form-control form-control-sm"
                                              defaultValue={selectedSurfaceCons}
                                              required
                                              onChange={handleSurfaceConsChange}
                                            />
                                          </Col>
                                        </Row>
                                        {/* Surface exploitée (ha) */}
                                        <Row className="mb-2">
                                          <Col
                                            xs={12}
                                            md={12}
                                            lg={4}
                                            style={colStyle}
                                          >
                                            <i style={{ color: "#9d9c9c" }}>
                                              <span>
                                                Surface exploitée (ha) :
                                              </span>
                                            </i>
                                          </Col>
                                          <Col className="col-md-6">
                                            <input
                                              className="form-control form-control-sm"
                                              defaultValue={selectedSurfaceExp}
                                              required
                                              onChange={handleSurfaceExpChange}
                                            />
                                          </Col>
                                        </Row>
                                        {/* Surface totale détenue (ha) */}
                                        <Row className="mb-2">
                                          <Col
                                            xs={12}
                                            md={12}
                                            lg={4}
                                            style={colStyle}
                                          >
                                            <i style={{ color: "#9d9c9c" }}>
                                              <span>
                                                Surface totale détenue (ha) :
                                              </span>
                                            </i>
                                          </Col>
                                          <Col className="col-md-6">
                                            <input
                                              className="form-control form-control-sm"
                                              defaultValue={selectedSurfaceTot}
                                              required
                                              onChange={handleSurfaceTotChange}
                                            />
                                          </Col>
                                        </Row>
                                        {/* Impact sur l'emploi */}
                                        <Row className="mb-2">
                                          <Col
                                            xs={12}
                                            md={12}
                                            lg={4}
                                            style={colStyle}
                                          >
                                            <i style={{ color: "#9d9c9c" }}>
                                              <span>Impact sur l'emploi :</span>
                                            </i>
                                          </Col>
                                          <Col className="col-md-6">
                                            <input
                                              className="form-control form-control-sm"
                                              defaultValue={selectedImpact}
                                              required
                                              onChange={handleImpactChange}
                                            />
                                          </Col>
                                        </Row>
                                      </CardBody>
                                    </Card>
                                  </Col>
                                </Row>
                              </Col>
                              <Col sm="12">
                                <>
                                  <Card className="mb-4">
                                    <CardTitle tag="h5">
                                      Données financières exploitant
                                    </CardTitle>
                                    <CardBody>
                                      <Col sm="12">
                                        <div className="table-responsive">
                                          <table
                                            className="table table-bordered rounded-3 overflow-hidden"
                                            style={{
                                              borderCollapse: "collapse",
                                              width: "100%",
                                            }}
                                          >
                                            <thead>
                                              <tr>
                                                {[
                                                  "Année",
                                                  "Capitaux propres (€)",
                                                  "Produits exploitation (€)",
                                                  "Charges exploitation (€)",
                                                  "Résultat exploitation (€)",
                                                ].map((columnName, index) => (
                                                  <th
                                                    className=""
                                                    style={tableaustyles}
                                                    key={index}
                                                  >
                                                    {columnName}
                                                  </th>
                                                ))}
                                                <th
                                                  className=""
                                                  style={{
                                                    background: "#555B21",
                                                    color: "white",
                                                    paddingTop: "5px",
                                                    paddingBottom: "5px",
                                                    width: "1%",
                                                  }}
                                                  key="Del"
                                                ></th>
                                              </tr>
                                            </thead>
                                            <tbody>
                                              {formDonneesFinanciere.map(
                                                (rowData) => (
                                                  <tr key={rowData.index}>
                                                    {Object.entries(
                                                      rowData
                                                    ).map(([key, value]) =>
                                                      key !== "id" &&
                                                      key !== "index" ? (
                                                        <td key={key}>
                                                          {key ===
                                                          "annee_id" ? (
                                                            <select
                                                              value={
                                                                value?.value
                                                              }
                                                              name="annee_id"
                                                              className="form-control form-control-sm"
                                                              onChange={(e) =>
                                                                handleInputFinanceChange(
                                                                  rowData.index,
                                                                  e.target.name,
                                                                  e.target.value
                                                                )
                                                              }
                                                            >
                                                              {renderAnneeOptions()}
                                                            </select>
                                                          ) : key ===
                                                            "capitaux_propres" ? (
                                                            <input
                                                              className="form-control form-control-sm"
                                                              type="number"
                                                              step="0.1"
                                                              defaultValue={
                                                                value
                                                              }
                                                              name={key}
                                                              onChange={(e) =>
                                                                handleInputFinanceChange(
                                                                  rowData.index,
                                                                  e.target.name,
                                                                  e.target.value
                                                                )
                                                              }
                                                            />
                                                          ) : key ===
                                                            "produits_exploitation" ? (
                                                            <input
                                                              className="form-control form-control-sm"
                                                              type="number"
                                                              step="0.1"
                                                              defaultValue={
                                                                value
                                                              }
                                                              name={key}
                                                              onChange={(e) =>
                                                                handleInputFinanceChange(
                                                                  rowData.index,
                                                                  e.target.name,
                                                                  e.target.value
                                                                )
                                                              }
                                                            />
                                                          ) : key ===
                                                            "charges_exploitation" ? (
                                                            <input
                                                              className="form-control form-control-sm"
                                                              type="number"
                                                              step="0.1"
                                                              defaultValue={
                                                                value
                                                              }
                                                              name={key}
                                                              onChange={(e) =>
                                                                handleInputFinanceChange(
                                                                  rowData.index,
                                                                  e.target.name,
                                                                  e.target.value
                                                                )
                                                              }
                                                            />
                                                          ) : key ===
                                                            "resultat_exploitation" ? (
                                                            <input
                                                              className="form-control form-control-sm"
                                                              type="number"
                                                              step="0.1"
                                                              defaultValue={
                                                                value
                                                              }
                                                              name={key}
                                                              onChange={(e) =>
                                                                handleInputFinanceChange(
                                                                  rowData.index,
                                                                  e.target.name,
                                                                  e.target.value
                                                                )
                                                              }
                                                            />
                                                          ) : (
                                                            <span>{value}</span>
                                                          )}
                                                        </td>
                                                      ) : (
                                                        <td
                                                          className="d-none"
                                                          key={key}
                                                        >
                                                          <input
                                                            type="hidden"
                                                            value={value}
                                                          />
                                                        </td>
                                                      )
                                                    )}
                                                    <td>
                                                      <i
                                                        className="bx bx-trash"
                                                        style={{
                                                          fontSize: "20px",
                                                          paddingTop: "5px",
                                                          textAlign: "center",
                                                          verticalAlign:
                                                            "middle",
                                                          cursor: "pointer",
                                                        }}
                                                        onClick={() =>
                                                          onDeleteFormDonneesFinanciere(
                                                            rowData.index
                                                          )
                                                        }
                                                      ></i>
                                                    </td>
                                                  </tr>
                                                )
                                              )}
                                              <tr>
                                                <td colSpan="9">
                                                  <input
                                                    type="button"
                                                    style={tableaustyles}
                                                    className="btn btn-info mt-3 mt-lg-0"
                                                    value="Ajouter"
                                                    onClick={
                                                      onAddFormDonneesFinanciere
                                                    }
                                                  />
                                                </td>
                                              </tr>
                                            </tbody>
                                          </table>
                                        </div>
                                      </Col>
                                    </CardBody>
                                  </Card>
                                </>
                              </Col>
                              <Col sm="12">
                                <>
                                  <Card className="mb-4">
                                    <CardTitle tag="h5">
                                      Données autres investissements
                                    </CardTitle>
                                    <CardBody>
                                      <Col sm="12">
                                        <div className="table-responsive">
                                          <table
                                            className="table table-bordered rounded-3 overflow-hidden"
                                            style={{
                                              borderCollapse: "collapse",
                                              width: "100%",
                                            }}
                                          >
                                            <thead>
                                              <tr>
                                                {[
                                                  "Année",
                                                  "Désignation investissement",
                                                  "Base éligible",
                                                  "Monteur",
                                                ].map((columnName, index) => (
                                                  <th
                                                    className=""
                                                    style={tableaustyles}
                                                    key={index}
                                                  >
                                                    {columnName}
                                                  </th>
                                                ))}
                                                <th
                                                  className=""
                                                  style={{
                                                    background: "#555B21",
                                                    color: "white",
                                                    paddingTop: "5px",
                                                    paddingBottom: "5px",
                                                    width: "1%",
                                                  }}
                                                  key="Del"
                                                ></th>
                                              </tr>
                                            </thead>
                                            <tbody>
                                              {formDonneesInvest.map(
                                                (rowData) => (
                                                  <tr key={rowData.index}>
                                                    {Object.entries(
                                                      rowData
                                                    ).map(([key, value]) =>
                                                      key !== "id" &&
                                                      key !== "index" ? (
                                                        <td key={key}>
                                                          {key ===
                                                          "annee_id" ? (
                                                            <select
                                                              value={
                                                                value?.value
                                                              }
                                                              name="annee_id"
                                                              className="form-control form-control-sm"
                                                              onChange={(e) =>
                                                                handleInputFinanceChange(
                                                                  rowData.index,
                                                                  e.target.name,
                                                                  e.target.value
                                                                )
                                                              }
                                                            >
                                                              {renderAnneeOptions()}
                                                            </select>
                                                          ) : key ===
                                                            "monteur" ? (
                                                            <input
                                                              className="form-control form-control-sm"
                                                              type="text"
                                                              defaultValue={
                                                                value
                                                              }
                                                              name={key}
                                                              onChange={(e) =>
                                                                handleInputInvestChange(
                                                                  rowData.index,
                                                                  e.target.name,
                                                                  e.target.value
                                                                )
                                                              }
                                                            />
                                                          ) : key ===
                                                            "base_eligible" ? (
                                                            <input
                                                              className="form-control form-control-sm"
                                                              type="number"
                                                              step="0.1"
                                                              defaultValue={
                                                                value
                                                              }
                                                              name={key}
                                                              onChange={(e) =>
                                                                handleInputInvestChange(
                                                                  rowData.index,
                                                                  e.target.name,
                                                                  e.target.value
                                                                )
                                                              }
                                                            />
                                                          ) : key ===
                                                            "designation" ? (
                                                            <input
                                                              className="form-control form-control-sm"
                                                              type="text"
                                                              defaultValue={
                                                                value
                                                              }
                                                              name={key}
                                                              onChange={(e) =>
                                                                handleInputInvestChange(
                                                                  rowData.index,
                                                                  e.target.name,
                                                                  e.target.value
                                                                )
                                                              }
                                                            />
                                                          ) : (
                                                            <span>{value}</span>
                                                          )}
                                                        </td>
                                                      ) : (
                                                        <td
                                                          className="d-none"
                                                          key={key}
                                                        >
                                                          <input
                                                            type="hidden"
                                                            value={value}
                                                          />
                                                        </td>
                                                      )
                                                    )}
                                                    <td>
                                                      <i
                                                        className="bx bx-trash"
                                                        style={{
                                                          fontSize: "20px",
                                                          paddingTop: "5px",
                                                          textAlign: "center",
                                                          verticalAlign:
                                                            "middle",
                                                          cursor: "pointer",
                                                        }}
                                                        onClick={() =>
                                                          onDeleteFormDonneesInvest(
                                                            rowData.index
                                                          )
                                                        }
                                                      ></i>
                                                    </td>
                                                  </tr>
                                                )
                                              )}
                                              <tr>
                                                <td colSpan="9">
                                                  <input
                                                    type="button"
                                                    style={tableaustyles}
                                                    className="btn btn-info mt-3 mt-lg-0"
                                                    value="Ajouter"
                                                    onClick={
                                                      onAddFormDonneesInvest
                                                    }
                                                  />
                                                </td>
                                              </tr>
                                            </tbody>
                                          </table>
                                        </div>
                                      </Col>
                                    </CardBody>
                                  </Card>
                                </>
                              </Col>
                            </Row>
                          </>
                        ) : (
                          <Spinners setLoading={setLoading} />
                        )}
                      </div>
                    )}
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </div>
        </div>
        <ToastContainer />
      </React.Fragment>
    </>
  );
}

export default EditCgp;
